
export const DOCTOR_CASE_DEPOSIT_LIST_PATH = '/app/doctor/case/deposit/list'
export const DOCTOR_CASE_DEPOSIT_DETAIL_PATH = '/app/doctor/case/deposit/detail'